<template>
  <!-- 收藏统计 -->
  <div class="userInterface">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['接口查询',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData">导出数据</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入关键字" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="ERP编号">
      </el-table-column>
      <el-table-column
        prop="name"
        align="center"
        show-overflow-tooltip
        label="单位名称">
      </el-table-column>
      <el-table-column
        prop="userName"
        align="center"
        show-overflow-tooltip
        label="联系人">
      </el-table-column>
      <el-table-column
        prop="tel"
        align="center"
        show-overflow-tooltip
        label="联系人电话">
      </el-table-column>
      <el-table-column
        prop="range"
        align="center"
        show-overflow-tooltip
        label="经营范围">
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        show-overflow-tooltip
        label="地址">
      </el-table-column>
      <el-table-column
        prop="type"
        align="center"
        show-overflow-tooltip
        label="客户分类">
      </el-table-column>
      <el-table-column
        prop="addressCode"
        align="center"
        show-overflow-tooltip
        label="区域分类编号">
      </el-table-column>
      <el-table-column
        prop="addressName"
        align="center"
        show-overflow-tooltip
        label="区域分类名称">
      </el-table-column>
      <el-table-column
        prop="nameSp"
        align="center"
        show-overflow-tooltip
        label="收货人">
      </el-table-column>
      <el-table-column
        prop="telSp"
        align="center"
        show-overflow-tooltip
        label="收货人电话">
      </el-table-column>
      <el-table-column
        prop="addressSp"
        align="center"
        show-overflow-tooltip
        label="收货人地址">
      </el-table-column>
      <el-table-column
        prop="ywy"
        align="center"
        show-overflow-tooltip
        label="业务员">
      </el-table-column>
      <el-table-column
        prop="xkz"
        align="center"
        show-overflow-tooltip
        label="许可证">
      </el-table-column>
      <el-table-column
        prop="yyzz"
        align="center"
        show-overflow-tooltip
        label="营业执照">
      </el-table-column>
      <el-table-column
        prop="gsp"
        align="center"
        show-overflow-tooltip
        label="GSP">
      </el-table-column>
      <el-table-column
        prop="wts"
        align="center"
        show-overflow-tooltip
        label="委托书">
      </el-table-column>
      <el-table-column
        prop="zbxy"
        align="center"
        show-overflow-tooltip
        label="质保协议">
      </el-table-column>
      <el-table-column
        prop="ylqx"
        align="center"
        show-overflow-tooltip
        label="医疗器械">
      </el-table-column>
      <el-table-column
        prop="ws"
        align="center"
        show-overflow-tooltip
        label="卫生">
      </el-table-column>
      <el-table-column
        prop="yljg"
        align="center"
        show-overflow-tooltip
        label="医疗机构执业许可">
      </el-table-column>
      <el-table-column
        prop="province"
        align="center"
        show-overflow-tooltip
        label="省">
      </el-table-column>
      <el-table-column
        prop="city"
        align="center"
        show-overflow-tooltip
        label="市">
      </el-table-column>
      <el-table-column
        prop="area"
        align="center"
        show-overflow-tooltip
        label="县">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'userInterface',
  data() {
    return {
      /**表格数据 */
      tableData: [],
      /**搜索表单 */
      searchForm: {
        name: ''
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    }
  },
  mounted() {
    this.getTableData()
  },
  methods:{
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        type: "Int_client_info",
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method: 'post',
        url: "goods/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then(res => {
        this.tableData = []
        this.allPage = 0
        if(res.flag == 0){
          this.allPage = res.recordCount
          this.tableData = res.data.map(item => ({
            id: item.dwbh, // ERP编号
            name: item.dwmch, // 单位名称
            userName: item.lxr, // 联系人
            tel: item.lxrdh, // 联系人电话
            range: item.jingyfw, // 经营范围
            address: item.dzhdh, // 地址
            type: item.kehufl, // 客户分类
            addressCode: item.quyufl, // 区域分类编号
            addressName: item.quyuflmc, // 区域分类名称
            nameSp: item.shouhr, // 收货人
            telSp: item.shouhrdh, // 收货人电话
            addressSp: item.shouhdz, // 收货人地址
            ywy: item.ywy, // 业务员
            xkz: item.xkzyxq, // 许可证
            yyzz: item.yyzzyxq, // 营业执照
            gsp: item.gspzsyxq, // GSP
            wts: item.wtsxq, // 委托书
            zbxy: item.zbxyyxq, // 质保协议
            ylqx: item.ylqxxkxq, // 医疗器械
            ws: item.wsxkzxq, // 卫生
            yljg: item.yljgzyxkzxq, // 医疗机构执业许可
            province: item.sheng, // 省
            city: item.shi, // 市
            area: item.xian, // 县
          }))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**刷新数据 */
    handleRefresh(){
      this.getTableData()
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val
      this.getTableData()
    },
    exportData(){
      let data = {
        type: "Int_client_info",
        strWhere: this.searchForm.name,
        userId: window.localStorage.getItem('userId'),
        entId: window.localStorage.getItem('entId'),
        PageIndex: 1,
        PageSize: 9999999,
      }
      let proc = "Proc_Admin_GoodsList" // 存储过程名
      window.location.href = this.baseUrl + "Order/NoPIGExprot?json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + encodeURIComponent(proc) + "&name=客户接口"
    },
  }
}
</script>

<style scoped>
.userInterface{
  width: 100%;
  height: 100%;
}
</style>
